import { render, staticRenderFns } from "./MpModal.vue?vue&type=template&id=3f90870e&scoped=true&"
import script from "./MpModal.vue?vue&type=script&lang=js&"
export * from "./MpModal.vue?vue&type=script&lang=js&"
import style0 from "./MpModal.vue?vue&type=style&index=0&id=3f90870e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f90870e",
  null
  
)

export default component.exports